import { BFFAgent } from "../../common/BFFAgent";
import { ESTADO_STOCK } from "../common/Constants";

const tooltipFactured = 'Este campo está desactivado porque el auto ya fue facturado'

export default {
  data: {
    data: {
      basicInfoSchema: {
        infoVehiculo: {
          _name: 'Información del vehículo',
          subversion: {
            name: 'Subversión',
            required: true,
            type: 'string',
          },
          branch_office_id: {
            name: 'Sucursal',
            required: true,
            type: 'AsyncSelectObj',
            endpoint: '/abms/branch_office/Car_lot/',
          },
          location_id: {
            name: 'Ubicación',
            required: true,
            type: 'AsyncSelectObj',
            endpoint: "/abms/location",
            selectFirstIfOneOption: true,
          },
          owner_id: {
            name: 'Concesionario Dueño',
            required: false,
            type: 'AsyncSelectObj',
            endpoint: '/abms/car_lot/product_owners'
          },
          patente: {
            name: 'Patente',
            required: true,
            type: 'text',
          },
          kilometros: {
            name: 'Kilometraje',
            required: true,
            type: 'number',
            limit: 7
          },
          año: {
            name: 'Año del modelo',
            required: true,
            type: 'number',
            disabled: true,
          },
          puntaje_comercial: {
            name: 'Puntaje Comercial',
            required: true,
            type: 'Radio1_10',
          },
          CODIGO: {
            name: 'Código',
            required: true,
            type: 'number',
          },
          COMBU: {
            name: 'Tipo Combustible',
            required: false,
            type: 'enum',
          },
          TRANSMI: {
            name: 'Transmisión',
            required: false,
            type: 'enum',
          },
          sale_type_id: {
            name: 'Tipo Venta',
            required: false,
            type: 'AsyncSelectObj',
            endpoint: '/saletypes',
          },
          SEGMENTO: {
            name: 'Segmento',
            required: true,
            type: 'AsyncSelect',
            endpoint: '/datamasters/segments',
          },
        },
        Monetizacion: {
          _name: 'Monetización',
          costo_compra: {
            name: 'Costo de compra',
            required: true,
            type: 'number',
            disableConditions: [ESTADO_STOCK.FACTURADO],
            tooltipFactured
          },
          exchange_rate_id: {
            name: 'Moneda de carga',
            required: true,
            type: 'AsyncSelectObj',
            endpoint: "/abms/exchange-rates",
            disableConditions: [ESTADO_STOCK.FACTURADO],
            tooltipFactured
          },
          precio_lista: {
            name: 'Precio de lista',
            required: false,
            type: 'number',
            disableConditions: [ESTADO_STOCK.FACTURADO],
            tooltipFactured
          },
          accessory_1: {
            name: 'Accesorio 1',
            required: false,
            type: 'number',
            disableConditions: [ESTADO_STOCK.FACTURADO],
            tooltipFactured
          },
          accessory_2: {
            name: 'Accesorio 2',
            required: false,
            type: 'number',
            disableConditions: [ESTADO_STOCK.FACTURADO],
            tooltipFactured
          },
          sale_price: {
            name: 'Precio Venta',
            required: false,
            type: 'number',
            disabled: true,
          },
          reference_price: {
            name: 'Precio de Referencia',
            required: true,
            disabled: true,
            type: 'text',
          },
          rp_update_date: {
            name: 'Fecha de actualización',
            required: false,
            type: 'dateText',
            disabled: true
          },
          rp_auto_update: {
            name: 'Actualización automática',
            required: false,
            type: 'trueBoolean',
            disabled: true,
            default: true
          },
          flete_alistaje: {
            name: 'Costo de Alistaje',
            required: false,
            type: 'number',
            disableConditions: [ESTADO_STOCK.FACTURADO],
            tooltipFactured
          },
          margin: {
            name: 'Margen $',
            required: false,
            type: 'number',
            disabled: true,
          },
          margin_percentage: {
            name: 'Margen %',
            required: false,
            type: 'string',
            disabled: true,
          },
        },
        Etiquetas: {
          _name: 'Etiquetas',
          labels: {
            name: 'Etiquetas',
            required: false,
            type: 'asyncChipDropdown',
            endpoint: BFFAgent.Catalogs.getLabels,
            className: 'grid-column-full-width'
          }
        },
        colores: {
          _name: 'Colores',
          colors: {
            name: 'Color',
            required: false,
            type: 'singleColor',
          },
        },
        multimedia: {
          _name: 'Multimedia y descripción',
          description: {
            name: 'Descripción',
            required: false,
            type: 'textarea',
          },
        },
      },
    },
  },
}
